import { parseError, agent, updateSessionObject } from 'utils/api'
import { notify } from '../utils/notification'
import constants from 'constants'
import { push } from 'react-router-redux'

export const REPORTS_RECEIVED_REPORTS = 'REPORTS_GET_REPORTS'
export const REPORTS_GETING_REPORTS = 'REPORTS_GETING_REPORTS'
export const REPORTS_ERROR = 'REPORTS_ERROR'
export const SETREPORTURL_RECEIVED_SETREPORTURL = 'SETREPORTURL_RECEIVED_SETREPORTURL'

const fetching = type => ({
  type,
})

const receive = (reports, type) => ({
  type,
  reports,
})

export const setReportUrl = (reportUrl, itemId) => ({
  type: SETREPORTURL_RECEIVED_SETREPORTURL,
  selectedReport: reportUrl,
  selectedReportId: itemId,
})

export function getReports(employeeId) {
  return (dispatch) => {
    dispatch(fetching(REPORTS_GETING_REPORTS))
    agent.Reports.getReports(employeeId)
      .then((result) => {
        dispatch(receive(result, REPORTS_RECEIVED_REPORTS))
      })
      .catch((rawError) => {
        console.error('Getting reports error')
        // console.error('getReports error', rawError, rawError.stack, window.location)
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching reports', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/reports.js